<template>
  <div class="about content">
    <div class="left-side slideUp">
      <div class="left-container">
        <h2>Sobre mí</h2>
        <p>
          ¡Hola! 👋 Soy Nicole Loupias, desarrolladora Front End y maquetadora
          web viviendo en Madrid.
        </p>
        <p>
          Me apasiona ver las cosas increíbles que puedo crear programando
          juntando código con creatividad.
        </p>
        <p>
          Me encantaría unirme a un equipo donde no solo pueda usar mis
          habilidades existentes, sino también expandirlas ya que siempre me
          encanta aprender cosas nuevas.
        </p>
        <p>
          Disfruto cuando tengo que superar retos y participar en proyectos que
          requieran que trabaje fuera de mi conjunto de conocimientos para poder
          aprender de ello.
        </p>

        <h3>Habilidades</h3>
        <ul class="habilidades">
          <li class="habilidad">JavaScript</li>
          <li class="habilidad">VueJS</li>
          <li class="habilidad">NuxtJS</li>
          <li class="habilidad">HTML5</li>
          <li class="habilidad">CSS3/Sass</li>
          <li class="habilidad">Responsive Web Design</li>
          <li class="habilidad">Git</li>
          <li class="habilidad">React</li>
          <li class="habilidad">Java</li>
          <li class="habilidad">Jest</li>
          <li class="habilidad">Python</li>
          <li class="habilidad">Scrum</li>
          <li class="habilidad">Android</li>
          <li class="habilidad">Bootstrap</li>
          <li class="habilidad">PHP</li>
          <li class="habilidad">MySQL</li>
          <li class="habilidad">MongoDB</li>

          <li class="habilidad">Phonegap</li>
          <li class="habilidad">Figma</li>
          <li class="habilidad">Photoshop</li>
        </ul>
        <a
          href="https://drive.google.com/file/d/1_XAKR0KPAFl1ee7EzlxXdrZtfZ8Gerwl/view"
          target="_blank"
          class="cv-link"
          >Descarga mi CV</a
        >
      </div>
    </div>

    <div class="img2 right-side">
      <div class="img-container">
        <img src="../assets/aboutImg.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
};
</script>

<style lang="scss" scoped>
.content {
  grid-template-columns: 50% 50%;
}
.left-container {
  margin: auto;
}
.right-side {
  background-color: white !important;
  max-height: 90vh;
}
.img2 {
  .img-container {
    position: relative;
    img {
      max-width: 450px;
      width: 80%;
      display: block;
      margin: auto;
    }
  }
}
.habilidades {
  width: 100%;
  list-style: none;
  display: grid;
  grid-template-columns: repeat(3, minmax(200px, 1fr));
  padding: 0;
  margin: 0;

  @media screen and (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(180px, 1fr));
  }

  @media screen and (max-width: 400px) {
    grid-template-columns: auto;
  }
  .habilidad {
    font-size: 13px;
    padding-left: 20px;
    margin: 4px;
    position: relative;
    font-family: "Space Mono", monospace;

    &::before {
      content: "▹";
      position: absolute;
      left: 0px;
      color: #f44647;
      font-size: 14px;
      line-height: 12px;
    }
  }
}
</style>
